import { type ChipProps, Chip as HChip } from '@heroui/react';
import type { Control, FieldValues, Path } from 'react-hook-form';
import { cn } from '../../cn';

export interface FormChipProps extends ChipProps {
  name?: Path<FieldValues>;
  control?: Control<FieldValues>;
  options: string[];
  onRemove?: (option: string) => void;
  wrapperClassName?: string;
  transformSelected?: (option: string) => string;
}

export const ChipGroup = ({
  name,
  control,
  options,
  onRemove,
  wrapperClassName,
  transformSelected,
  ...props
}: FormChipProps) => {
  return (
    <div className={cn('flex flex-wrap gap-1', wrapperClassName)}>
      {options.map((option) => (
        <HChip key={option} variant='flat' onClose={() => onRemove?.(option)} {...props}>
          {transformSelected ? transformSelected(option) : option}
        </HChip>
      ))}
    </div>
  );
};

export const Chip = (props: ChipProps) => {
  return <HChip {...props} />;
};
